import './polyfills/mic-recorder-polyfill';
import { getRegionCode } from './helpers/RegionCodes';

// Initialize zynga scroller globals early
import './components/zynga/Scroller';

async function initializeApp() {
  if (window.location.pathname.indexOf('/popup_callback') === 0) {
    const { default: popupCallback } = await import('./auth/PopupCallback');
    popupCallback();
    return;
  }

  if (window.location.pathname.indexOf('/silent_renew') === 0) {
    const { default: silentRenew } = await import('./auth/SilentRenew');
    silentRenew();
    return;
  }

  if (window.location.pathname.indexOf('/set-logout') === 0) {
    const { setLogoutSignal } = await import('./auth/AuthService');
    setLogoutSignal();
    return;
  }

  if (window.location.pathname.indexOf('/set-regioncode') === 0) {
    getRegionCode();
    return;
  }

  if (window.location.pathname.indexOf('/switch-account') === 0) {
    const { setSwitchAccountSignal } = await import('./auth/AuthService');
    setSwitchAccountSignal();
    return;
  }

  if (window.location.pathname.indexOf('/sift-session') === 0) {
    const { setSiftSessionIdFromUrl } = await import('./Sift');
    setSiftSessionIdFromUrl();
    return;
  }

  // go to the main app
  const { default: library } = await import('./library');
  await library('goformz-app');
}

// Initialize the app
initializeApp().catch(console.error);
